import { UserServiceService } from './../user-service.service';
import { GoogleSheetScoreService } from './../GoogleSheetScore.service';
import { Component, OnInit , NgZone } from '@angular/core';
import {activities} from '../activities'
import { Input } from '@angular/core';
import * as CanvasJS from '../../assets/canvasjs.min.js';
import { User } from 'firebase';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})


export class HomePageComponent implements OnInit {
  private chart: am4charts.RadarChart;
  private chart2: am4charts.XYChart;
  activities = activities;
  homeworks;
  fullhomeworks;
  mcRecord;
  mcStat;
  
  mcChart;
  loading = false;
  constructor(
	  private GoogleSheetScoreService: GoogleSheetScoreService,
	  private UserServiceService: UserServiceService,
	  private zone: NgZone
  ) { }
  
 
  ngOnInit() {	

	this.homeworks = this.GoogleSheetScoreService.getScore(false,"self");
	this.fullhomeworks = this.GoogleSheetScoreService.getFullScore(true,"self");	
	this.mcRecord = this.UserServiceService.getMCRecord();
	this.mcStat = this.UserServiceService.getMCStat();
	
    }
	@Input('matTooltipClass')
	tooltipClass: any
	
	loadChart(reload) {
		if (reload){
		  this.chart.dispose();
		}
		if((!this.chart || reload) && !this.loading){
	
		  console.log("Loading...")
		  this.loading = true;
		this.zone.runOutsideAngular(() => {	
		  var xhr = new XMLHttpRequest();        
		
		  xhr.open('GET', 'https://api.studydse.net/api/get_student_radar_chart.php');
		  xhr.withCredentials = true;
		 // xhr.open('GET', '/assets/chart.json');
		  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		  xhr.onload = () => {
		   let data = JSON.parse(xhr.responseText);
		   var chart = am4core.create("chartContainer5", am4charts.RadarChart);

			var title = chart.titles.push(new am4core.Label());
					title.text = "My Performance on DSE Topic";
					title.fontSize = 25;
					title.marginBottom = 25;

			/* Add data */
			chart.data = data;

			/* Create axes */
			var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis() as any);
			categoryAxis.dataFields.category = "tag";

			var valueAxis = chart.yAxes.push(new am4charts.ValueAxis() as any);
			valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
			valueAxis.renderer.axisFills.template.fillOpacity = 0.05;

			/* Create and configure series */
			var series = chart.series.push(new am4charts.RadarSeries());
			series.dataFields.valueY = "school_rate";
			series.dataFields.categoryX = "tag";
			series.name = "School Correct Rate";
			series.strokeWidth = 3;
			series.bullets.create(am4charts.CircleBullet);
			series.tooltipText = "School: {valueY}%";


			var series2 = chart.series.push(new am4charts.RadarSeries());
			series2.dataFields.valueY = "student_rate";
			series2.dataFields.categoryX = "tag";
			series2.name = "Your Correct Rate";
			series2.strokeWidth = 3;
			series2.bullets.create(am4charts.CircleBullet);
			series2.tooltipText = "You: {valueY}%";

			var series3 = chart.series.push(new am4charts.RadarSeries());
			series3.dataFields.valueY = "hk_rate";
			series3.dataFields.categoryX = "tag";
			series3.name = "HK Correct Rate";
			series3.strokeWidth = 3;
			series3.bullets.create(am4charts.CircleBullet);
			series3.tooltipText = "HK: {valueY}%";


			chart.cursor = new am4charts.RadarCursor();

			chart.legend = new am4charts.Legend();
	 
		   this.chart = chart;
		   this.loading = false;
		  };
		  xhr.send();
	
	
		  
	
		});
		
	  }
	  }

	  loadChart2(reload) {
		if (reload){
		  this.chart2.dispose();
		}
		if((!this.chart2 || reload) && !this.loading){
	
		  console.log("Loading...")
		  this.loading = true;
		this.zone.runOutsideAngular(() => {	
		  var xhr = new XMLHttpRequest();        
		
		  xhr.open('GET', 'https://api.studydse.net/api/get_topic_correct_chart.php');
		  xhr.withCredentials = true;
		 // xhr.open('GET', '/assets/chart.json');
		  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		  xhr.onload = () => {
		   let data = JSON.parse(xhr.responseText);
		   var chart = am4core.create("chartContainer6", am4charts.XYChart);

var title = chart.titles.push(new am4core.Label());
					title.text = "My Total Score on All Topics";
					title.fontSize = 25;
					title.marginBottom = 25;

			
			var value = 120;


			chart.data =data;
			var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.renderer.grid.template.location = 0;
			categoryAxis.dataFields.category = "tag";
			categoryAxis.renderer.minGridDistance = 15;
			categoryAxis.renderer.grid.template.location = 0.5;
			categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
			categoryAxis.renderer.labels.template.rotation = -90;
			categoryAxis.renderer.labels.template.horizontalCenter = "left";
			categoryAxis.renderer.labels.template.location = 0.5;

			categoryAxis.renderer.labels.template.adapter.add("dx", function(dx, target) {
				return -target.maxRight / 2;
			})

			var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.tooltip.disabled = true;
			valueAxis.renderer.ticks.template.disabled = true;
			valueAxis.renderer.axisFills.template.disabled = true;
			valueAxis.title.text = "No. of Correct Answer / Exercises";
			var series = chart.series.push(new am4charts.ColumnSeries());
			series.dataFields.categoryX = "tag";
			series.dataFields.valueY = "score";
			series.name = "No. of Correct Answers";
			series.tooltipText = "{valueY.score}";
			series.sequencedInterpolation = true;
			series.fillOpacity = 0;
			series.strokeOpacity = 1;
			
			series.columns.template.width = 0.01;
			series.tooltip.pointerOrientation = "horizontal";

			var series2 = chart.series.push(new am4charts.ColumnSeries());
			series2.dataFields.categoryX = "tag";
			series2.dataFields.valueY = "times";
			series2.name = "No. of Exercises";
			series2.tooltipText = "{valueY.times}";
			series2.sequencedInterpolation = true;
			series2.fillOpacity = 0;
			series2.strokeOpacity = 1;
			
			series2.columns.template.width = 0.01;
			series2.tooltip.pointerOrientation = "horizontal";

			var bullet = series.bullets.create(am4charts.CircleBullet);
			var bullet2 = series2.bullets.create(am4charts.CircleBullet);
			chart.cursor = new am4charts.XYCursor();

			chart.scrollbarX = new am4core.Scrollbar();
			chart.scrollbarY = new am4core.Scrollbar();
			chart.legend = new am4charts.Legend();
	 
		   this.chart2 = chart;
		   this.loading = false;
		  };
		  xhr.send();
	
	
		  
	
		});
		
	  }
	  }
	  ngOnDestroy() {
		this.zone.runOutsideAngular(() => {
		  if (this.chart) {
			this.chart.dispose();
		  }
		 
		});
	  }

}
